<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div class="findSalon">
    <p class="font-s title">{{ item.Title }}</p>
    <p class="description" v-if="item.Description">{{ item.Description }}</p>
    <div>
      <p class="label">{{ item.CityLabel }}</p>
      <div class="input-block" v-if="!useYext">
        <input
          v-on:blur="inputPlacholder = item.CityLabel"
          v-on:focus="inputPlacholder = ''"
          :placeholder="inputPlacholder"
          v-model="salonText"
          type="input"
          @keyup.enter="inputChange()"
        />
        <button class="location" @click="inputChange" aria-label="set location">
          <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0902 11.5703C10.9186 11.5703 11.5902 10.8987 11.5902 10.0703C11.5902 9.24189 10.9186 8.57031 10.0902 8.57031C9.26175 8.57031 8.59018 9.24189 8.59018 10.0703C8.59018 10.8987 9.26175 11.5703 10.0902 11.5703ZM10.0902 13.5703C12.0232 13.5703 13.5902 12.0033 13.5902 10.0703C13.5902 8.13732 12.0232 6.57031 10.0902 6.57031C8.15718 6.57031 6.59018 8.13732 6.59018 10.0703C6.59018 12.0033 8.15718 13.5703 10.0902 13.5703Z" fill="black"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.20779 5.59973C3.0956 2.06005 6.19034 0.0703125 10.0901 0.0703125C13.9557 0.0703125 17.3226 2.06083 18.9963 5.64742C20.9447 9.82243 19.7871 13.6973 17.7427 16.8628C15.7509 19.947 12.8315 22.5008 10.85 24.2342C10.8159 24.264 10.7821 24.2936 10.7486 24.3229L10.0901 24.8991L9.43164 24.3229C9.26977 24.1812 9.10006 24.0337 8.92372 23.8803C6.96035 22.173 4.17583 19.7516 2.25812 16.875C0.142492 13.7016 -1.0296 9.79486 1.20779 5.59973ZM10.0901 2.07031C6.98994 2.07031 4.54239 3.59734 2.9725 6.5409C1.20991 9.84577 2.03784 12.939 3.92222 15.7656C5.63367 18.3328 8.12427 20.5311 10.0882 22.242C12.0184 20.5421 14.4073 18.3408 16.0626 15.7778C17.8932 12.9433 18.7357 9.8182 17.184 6.4932C15.8578 3.65137 13.2245 2.07031 10.0901 2.07031Z" fill="black"/>
          </svg>
        </button>
      </div>
      <div v-if="useYext">
        <slot></slot>
      </div>
      <p v-if="inputError" class="input-error">{{ item.ErrorText }}</p>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'find-salon',
  props: {
    item: {
      type: Object,
    },
    imgAlt: {
      type: String,
      default: 'locator for salon',
    },
    useYext: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      default: 'footer',
    }
  },
  data() {
    return {
      salonText: '',
      inputError: false,
      inputPlacholder: this.item.CityLabel,
    };
  },
  methods: {
    inputChange() {
      const regexpattern = /^[a-zA-Z0-9]+$/;
      //check for empty input
      if (this.salonText) {
        // check for valid input
        if (regexpattern.test(this.salonText)) {
          if(this.item && this.item.Tagging) {
            const eventData = typeof this.item.Tagging === 'string' ? JSON.parse(this.item.Tagging) : this.item.Tagging;
            eventData.link_url = eventData.link_url.replace("{0}", this.salonText);
            window.dataLayer.push(eventData);
          };
          this.inputError = false;
          const arr = this.item.RedirectUrl.split('?');
          if (arr[1] != undefined) {
            window.open(
              `${arr[0]}?query=${this.salonText}&${arr[1].split('&')[1]}`
            );
          }
        } else {
          this.inputError = true;
        }
      } else {
        this.inputError = true;
      }
    },
  },
};
</script>
